import React from 'react';
import { Link } from 'react-router-dom';

function TestimoniItem(props) {
  return (
    <>
      <li className='testimoni__item'>
        <Link className='testimoni__item__link' to={props.path}>
          <figure className='testimoni__item__pic-wrap' data-category={props.label}>
            <img
              className='testimoni__item__img'
              alt='DKP'
              src={props.src}
            />
          </figure>
          <div className='testimoni__item__info'>
            <h5 className='testimoni__item__text'>{props.text}</h5>
          </div>
        </Link>
      </li>
    </>
  );
}

export default TestimoniItem;
